import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Lock, Sparkles, ArrowRight } from 'lucide-react';

const UpgradePrompt = ({ 
  feature = "this feature",
  title = "Unlock Full Access",
  description = null,
  compact = false 
}) => {
  if (compact) {
    return (
      <div className="flex items-center gap-3 p-3 bg-amber-50 dark:bg-amber-900/30 rounded-lg border border-amber-200 dark:border-amber-800">
        <Lock className="w-5 h-5 text-amber-600 dark:text-amber-400" />
        <span className="text-sm text-navy-700 dark:text-navy-200">
          <Link to="/membership" className="text-amber-600 hover:text-amber-700 font-medium">
            Upgrade to access {feature}
          </Link>
        </span>
      </div>
    );
  }

  return (
    <Card className="border-amber-200 dark:border-amber-800 bg-gradient-to-br from-amber-50 to-white dark:from-amber-900/20 dark:to-navy-800">
      <CardContent className="p-6 text-center">
        <div className="w-16 h-16 bg-amber-100 dark:bg-amber-900/50 rounded-full flex items-center justify-center mx-auto mb-4">
          <Lock className="w-8 h-8 text-amber-600 dark:text-amber-400" />
        </div>
        <h3 className="font-heading text-xl font-semibold text-navy-900 dark:text-white mb-2">
          {title}
        </h3>
        <p className="text-navy-600 dark:text-navy-300 mb-6">
          {description || `Activate your Atlas membership to access ${feature} and all premium features.`}
        </p>
        <Link to="/membership">
          <Button className="bg-amber-600 hover:bg-amber-700">
            <Sparkles className="w-4 h-4 mr-2" />
            Activate Membership
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </Link>
      </CardContent>
    </Card>
  );
};

export default UpgradePrompt;
